export default __webpack_public_path__ + "static/media/facebook.4ceadf7e.svg";